import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Toast } from 'primereact/toast';
import { InputTextarea } from 'primereact/inputtextarea'
import CircularProgress from '@mui/material/CircularProgress';
import { InputNumber } from 'primereact/inputnumber'
import Backdrop from '@mui/material/Backdrop';
import { DataTable } from 'primereact/datatable'
import { Tag } from 'primereact/tag';
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect'
import { InputMask } from 'primereact/inputmask';
import { uniqueId } from "lodash"
import filesize from 'filesize'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'

import NavBar from '../../componentes/Navbar'

import ContaFinanceiraService from '../../app/service/ContaFinanceiraService'
import TransferenciaFinanceiraService from '../../app/service/TransferenciaFinanceiraService'

class ContaFinanceira extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSpinner: false,
      contas: [],
      conta: null,
      codigoConta: '',
      nomeConta: '',
      saldo: '',
      tipoConta: null,
      modalCadastrarConta: false,
      modalAlterarConta: false,
      statusConta: null,
      //Especialização de Banco
      exibirCadastroAgenca: 'none',
      codigoBanco: '',
      numeroAgencia: '',
      numeroConta: '',
      tipoContaBanco: null,
      detail: '',
      //Transferência entre contas
      contasAtivas: [],
      origem: null,
      destino: null,
      valorTransferencia: '',
      observacaoTransferencia: '',
      modalTransferencia: false,
      modalConsultaTransferencias: false,
      upLoadFiles:[],
      dataFiles: null,
      exibirArquivo: 'none',
      fileName: '',
      transferencias: [],
      transferencia: null,
      //Filtros
      transfDataInicial: '',
      transfDataFinal: '',
      transfConta: null,
      transfTipo: null,
      transfCodigo: '',
    };

    this.contaFinanceiraService = new ContaFinanceiraService();
    this.transferenciaFinanceiraService = new TransferenciaFinanceiraService();

    this.renderFooterCadastroConta = this.renderFooterCadastroConta.bind(this);
    this.renderFooterAlterarConta = this.renderFooterAlterarConta.bind(this);
    this.onChangeBanco = this.onChangeBanco.bind(this);
    this.acoesContas = this.acoesContas.bind(this);

    this.tiposContas = [
      {codigo: 'B', nome: 'Banco'},
      {codigo: 'C', nome: 'Caixa'}
    ];

    this.tipos = [
      {codigo: 'O', nome: 'Origem'},
      {codigo: 'D', nome: 'Destino'},
      {codigo: 'T', nome: 'Ambos'}
    ]

    this.tiposContasBancos = [
      {codigo: 'C', nome: 'Conta Corrente'},
      {codigo: 'P', nome: 'Conta Poupança'}
    ];

    this.status = [
      {codigo: 'A', nome: 'Ativo'},
      {codigo: 'I', nome: 'Inativo'}
    ]
  }

  onChangeBanco(e) {
    if(e.value != null) {
      if(e.value.codigo == 'B') {
        this.setState({exibirCadastroAgenca: 'block'});
      } else {
        this.setState({exibirCadastroAgenca: 'none'});
      }

      this.setState({tipoConta: e.value});
    } else {
      this.setState({exibirCadastroAgenca: 'none'});
      this.setState({tipoConta: null});
    }
  }

  consultarTransferenciasTela = () => {
    this.abrirModal('modalConsultaTransferencias');
  }

  consultarTransferencias = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var dataInicial = 'N';
    var dataFinal = 'N';
    var conta = 0;
    var tipo = 'T';
    var codigo = 1;

    if(this.state.transfDataInicial != '' && this.state.transfDataInicial != null &&
       this.state.transfDataFinal != '' && this.state.transfDataFinal != null) {
        var date = this.state.transfDataInicial;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataInicial =  year+"-"+month+"-"+day;

        date = this.state.transfDataFinal;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFinal =  year+"-"+month+"-"+day;
    }

    if(this.state.transfConta != null) {
      conta = this.state.transfConta.codigo;
    }

    if(this.state.transfTipo != null) {
      tipo = this.state.transfTipo.codigo;
    }

    if(dataInicial == 'N' && dataFinal == 'N' && conta == 0) {
      codigo = 0;
    }

    const filtro = {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      conta: conta,
      tipo: tipo,
      codigo: codigo,
      empresa: usuarioLogado.empresa.codigo
    }

    this.setState({openSpinner: true});
    await this.transferenciaFinanceiraService.consultarTransferencias(filtro)
      .then(response => {
        this.setState({transferencias: response.data});
        this.abrirModal('modalConsultaTransferencias');
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Consulta TRansferências', detail:`${error}`, life: 4000});
        this.setState({openSpinner: false});
      });

      this.setState({openSpinner: false});

  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  listarContasAtivas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.contaFinanceiraService.listarAtivos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({contasAtivas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Contas Financeiras Ativas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  novaTransferencia = async () => {
    this.setState({origem: null});
    this.setState({destino: null});
    this.setState({observacaoTransferencia: ''});
    this.setState({valorTransferencia: ''});
    this.setState({openSpinner: true});
    this.setState({exibirArquivo: 'none'});
    await this.listarContasAtivas();
    this.abrirModal('modalTransferencia');
    this.setState({openSpinner: false});
  }

  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarFiles);
  }

  processarFiles = async (upLoadFile) => {
    const data = new FormData();
    data.append('file',upLoadFile.file);
    await this.transferenciaFinanceiraService.incluirArquivo(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.setState({exibirArquivo: 'block'});
        this.setState({dataFiles: response.data});
        this.setState({fileName: response.data.fileName});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  excluirArquivo = () => {
    this.setState({fileName: ''});
    this.setState({dataFiles: null});
    this.setState({exibirArquivo: 'none'});
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  transferir = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.origem == null) {
      this.toast.show({severity:'error', summary: 'Transferência de Contas', detail:'Informe a conta de origem', life: 4000});
      return;
    }

    if(this.state.destino == null) {
      this.toast.show({severity:'error', summary: 'Transferência de Contas', detail:'Informe a conta de destino', life: 4000});
      return;
    }

    if(this.state.valorTransferencia == '') {
      this.toast.show({severity:'error', summary: 'Transferência de Contas', detail:'Informe valor da transferência', life: 4000});
      return;
    }

    var file = null;
    var tipo = '';
    var fileName = '';

    if(this.state.dataFiles != null) {
      file = this.state.dataFiles.file;
      tipo = this.state.dataFiles.tipo;
      fileName = this.state.dataFiles.fileName
    }

    const transf = {
      origem: this.state.origem,
      destino: this.state.destino,
      valor: this.state.valorTransferencia,
      observacao: this.state.observacaoTransferencia,
      usuario: usuarioLogado,
      file: file,
      tipoFile: tipo,
      fileName: fileName
    }

    this.setState({openSpinner: true});
    await this.transferenciaFinanceiraService.transferir(transf)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Transferência de Contas', detail:'Transferência realizada com sucesso', life: 4000});
        this.consultarTransferencias();
        this.listarContas();
        this.fecharModal('modalTransferencia');
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Transferência de Contas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarContas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.contaFinanceiraService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({contas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarConta(conta) {
    this.setState({openSpinner: true});
    await this.contaFinanceiraService.consultar(conta.codigo)
      .then(response => {
        this.setState({conta: response.data});
        this.setState({nomeConta: response.data.nome});
        this.setState({saldo: response.data.saldo});
        if(response.data.status == 'Ativo') {
          this.setState({statusConta: {
            codigo: 'A',
            nome: 'Ativo'
          }});
        } else {
          this.setState({statusConta: {
            codigo: 'I',
            nome: 'Inativo'
          }});
        }
        if(response.data.tipoConta == 'Banco') {
          this.setState({tipoConta: {
            codigo: 'B',
            nome: 'Banco'
          }});

          this.setState({exibirCadastroAgenca: 'block'});
          this.setState({codigoBanco: response.data.agencia.codigoBanco});
          this.setState({numeroAgencia: response.data.agencia.numeroAgencia});
          this.setState({numeroConta: response.data.agencia.numeroConta});
          if(response.data.agencia.tipoConta == 'C') {
            this.setState({tipoContaBanco: {
              codigo: 'C',
              nome: 'Conta Corrente'
            }});
          } else {
            this.setState({tipoContaBanco: {
              codigo: 'P',
              nome: 'Conta Poupança'
            }})
          }
        } else {
          this.setState({tipoConta: {
            codigo: 'C',
            nome: 'Caixa'
          }});
          this.setState({exibirCadastroAgenca: 'none'});
        }

        this.abrirModal('modalAlterarConta');
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesContas(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarConta(rowData)}
                tooltip="Editar Conta" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoConta(rowData)} 
                tooltip="Excluir Conta" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  novaConta = () => {
    this.setState({nomeConta: ''});
    this.setState({tipoConta: null});
    this.setState({saldo: ''});
    this.abrirModal('modalCadastrarConta');
  }

  renderFooterCadastroConta(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarNovaConta}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarConta(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarConta}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  cadastrarNovaConta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nomeConta == '') {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o nome da conta', life: 4000});
      return;
    }

    if(this.state.tipoConta == null) {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o tipo de conta financeira', life: 4000});
      return;
    }

    if(this.state.saldo == '') {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o saldo da conta', life: 4000});
      return;
    }

    if(this.state.tipoConta.codigo == 'B') {
      if(this.state.numeroAgencia == '') {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Infome o número da agência', life: 4000});
        return;
      }

      if(this.state.numeroConta == '') {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o número da conta', life: 4000});
        return;
      }
     
      if(this.state.tipoContaBanco == null) {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o tipo de conta de banco', life: 4000});
        return;
      }
    }

    let conta = null;

    if(this.state.tipoConta.codigo == 'C') {
      conta = {
        nome: this.state.nomeConta,
        saldo: this.state.saldo,
        tipoConta: this.state.tipoConta.codigo,
        empresa: usuarioLogado.empresa
      };
    } else {
      conta = {
        nome: this.state.nomeConta,
        saldo: this.state.saldo,
        tipoConta: this.state.tipoConta.codigo,
        empresa: usuarioLogado.empresa,
        agencia: {
          codigoBanco: this.state.codigoBanco,
          numeroAgencia: this.state.numeroAgencia,
          numeroConta: this.state.numeroConta,
          tipoConta: this.state.tipoContaBanco.codigo
        }
      };
    }

    this.setState({openSpinner: true});
    await this.contaFinanceiraService.cadastrar(conta)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Contas Financeiras', detail:'Conta cadastrada com sucesso', life: 4000});
        this.listarContas();
        this.fecharModal('modalCadastrarConta');
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  alterarConta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nomeConta == '') {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o nome da conta', life: 4000});
      return;
    }

    if(this.state.tipoConta == null) {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o tipo de conta financeira', life: 4000});
      return;
    }

    if(this.state.saldo == '') {
      this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o saldo da conta', life: 4000});
      return;
    }

    if(this.state.tipoConta.codigo == 'B') {
      if(this.state.numeroAgencia == '') {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Infome o número da agência', life: 4000});
        return;
      }

      if(this.state.numeroConta == '') {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o número da conta', life: 4000});
        return;
      }
     
      if(this.state.tipoContaBanco == null) {
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:'Informe o tipo de conta de banco', life: 4000});
        return;
      }
    }

    let conta = null;

    if(this.state.tipoConta.codigo == 'C') {
      conta = {
        codigo: this.state.conta.codigo,
        nome: this.state.nomeConta,
        saldo: this.state.saldo,
        tipoConta: this.state.tipoConta.codigo,
        empresa: usuarioLogado.empresa,
        status: this.state.statusConta.codigo
      };
    } else {
      conta = {
        codigo: this.state.conta.codigo,
        nome: this.state.nomeConta,
        saldo: this.state.saldo,
        tipoConta: this.state.tipoConta.codigo,
        empresa: usuarioLogado.empresa,
        status: this.state.statusConta.codigo,
        agencia: {
          codigoBanco: this.state.codigoBanco,
          numeroAgencia: this.state.numeroAgencia,
          numeroConta: this.state.numeroConta,
          tipoConta: this.state.tipoContaBanco.codigo
        }
      };
    }

    this.setState({openSpinner: true});
    await this.contaFinanceiraService.alterar(conta)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Contas Financeiras', detail:'Conta alterada com sucesso', life: 4000});
        this.listarContas();
        this.fecharModal('modalAlterarConta');
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  confirmaExclusaoConta(conta) {
    this.setState({conta: conta});
    confirmDialog({
        message: 'Deseja realmente excluir a conta financeira?',
        header: 'Exclusão de conta financira',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirContaFinanceira,
        reject: this.reject
    });
  }

  excluirContaFinanceira = async () => {
    this.setState({openSpinner: true});
    await this.contaFinanceiraService.excluir(this.state.conta.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Contas Financeiras', detail:'Conta financeira excluída com sucesso', life: 4000});
        this.listarContas();
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  componentDidMount() {
    this.listarContas();
  }

  render() {
    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fa fa-money-check-alt nav-icon"></i>
                        <span>  Contas Financeiras</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={this.novaConta}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                            &nbsp;
                            &nbsp;
                            <button type="button" className="btn btn-success bg-gradient-success" 
                                    onClick={this.consultarTransferenciasTela}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="pi pi-dollar"></i> Transferências entre contas</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <DataTable value={this.state.contas}  responsiveLayout="scroll"
                            emptyMessage="Nenhuma conta criada">
                          <Column field="nome" header="Conta"></Column>
                          <Column field="tipoConta" header="Tipo"></Column>
                          <Column field="saldoFormat" header="Saldo"></Column>
                          <Column field="status" header="Status"></Column>
                          <Column body={this.acoesContas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/**Cadastrar Conta Financeira */}
            <Dialog header="Cadastrar Conta Financeira"
                      visible={this.state.modalCadastrarConta} 
                      style={{ width: '40vw' }} 
                      footer={this.renderFooterCadastroConta('modalCadastrarConta')} 
                      onHide={() => this.fecharModal('modalCadastrarConta')}>
                  
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="contaFinanceira">Nome da Conta</label>
                        <InputText id="contaFinanceira" 
                                  type="text" 
                                  style={{width: '100%', height: '32px'}}
                                  value={this.state.nomeConta}
                                  onChange={e => this.setState({nomeConta: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="formGroup">
                        <label htmlFor="tipoConta">Tipo de Conta</label>
                        <Dropdown value={this.state.tipoConta} 
                                  options={this.tiposContas} 
                                  style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={this.onChangeBanco}
                                  id="tipoConta"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="formGroup">
                        <label htmlFor="saldo">Saldo</label>
                        <InputNumber inputId="saldo" 
                                    value={this.state.saldo} 
                                    style={{width: '100%', height: '32px'}} 
                                    onChange={(e) => this.setState({saldo: e.value})} 
                                    mode="decimal" locale="de-BR" minFractionDigits={2}/>
                      </div>
                    </div>
                  </div>
                  <div style={{display: `${this.state.exibirCadastroAgenca}`}}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="codigoBanco">Código do Banco</label>
                          <InputText id="codigoBanco" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.codigoBanco}
                                    onChange={e => this.setState({codigoBanco: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroAgencia">Número da Agência</label>
                          <InputText id="numeroAgencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.numeroAgencia}
                                    onChange={e => this.setState({numeroAgencia: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroConta">Número da Conta</label>
                          <InputText id="numeroConta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.numeroConta}
                                    onChange={e => this.setState({numeroConta: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroConta">Tipo de Conta Bancária</label>
                          <Dropdown value={this.state.tipoContaBanco} 
                                    options={this.tiposContasBancos} 
                                    style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({tipoContaBanco: e.value})}
                                    id="tipoConta"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                  </div>
            </Dialog>

            {/**Alterar Conta Financeira */}
            <Dialog header="Alterar Conta Financeira"
                      visible={this.state.modalAlterarConta} 
                      style={{ width: '40vw' }} 
                      footer={this.renderFooterAlterarConta('modalAlterarConta')} 
                      onHide={() => this.fecharModal('modalAlterarConta')}>
                  
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="contaFinanceira">Nome da Conta</label>
                        <InputText id="contaFinanceira" 
                                  type="text" 
                                  style={{width: '100%', height: '32px'}}
                                  value={this.state.nomeConta}
                                  onChange={e => this.setState({nomeConta: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="formGroup">
                        <label htmlFor="tipoConta">Tipo de Conta</label>
                        <Dropdown value={this.state.tipoConta} 
                                  options={this.tiposContas} 
                                  style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={this.onChangeBanco}
                                  id="tipoConta"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="formGroup">
                        <label htmlFor="saldo">Saldo</label>
                        <InputNumber inputId="saldo" 
                                    value={this.state.saldo} 
                                    style={{width: '100%', height: '32px'}} 
                                    onChange={(e) => this.setState({saldo: e.value})} 
                                    mode="decimal" locale="de-BR" minFractionDigits={2}/>
                      </div>
                    </div>
                  </div>
                  <div style={{display: `${this.state.exibirCadastroAgenca}`}}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="codigoBanco">Código do Banco</label>
                          <InputText id="codigoBanco" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.codigoBanco}
                                    onChange={e => this.setState({codigoBanco: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroAgencia">Número da Agência</label>
                          <InputText id="numeroAgencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.numeroAgencia}
                                    onChange={e => this.setState({numeroAgencia: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroConta">Número da Conta</label>
                          <InputText id="numeroConta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.numeroConta}
                                    onChange={e => this.setState({numeroConta: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label htmlFor="numeroConta">Tipo de Conta Bancária</label>
                          <Dropdown value={this.state.tipoContaBanco} 
                                    options={this.tiposContasBancos} 
                                    style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({tipoContaBanco: e.value})}
                                    id="tipoConta"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="statusConta">Status</label>
                        <Dropdown value={this.state.statusConta} 
                                  options={this.status} 
                                  style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={e => this.setState({statusConta: e.value})}
                                  id="statusConta"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
            </Dialog>
             {/**Transferência entre contas */}
             <Dialog header="Transferência entre contas"
                      visible={this.state.modalTransferencia} 
                      style={{ width: '40vw' }} 
                      footer={
                        <div>
                            <Button label="Transferir" 
                                    className="p-button-primary p-button-text"
                                    onClick={this.transferir}/> 
                            &nbsp;
                            <Button label="Cancelar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalTransferencia')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalTransferencia')}>
                  
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="statusConta">Conta de Origem</label>
                        <Dropdown value={this.state.origem} 
                                  options={this.state.contasAtivas} 
                                  style={{width: '100%', height: '32px'}}
                                  optionLabel="nomeFormat" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nomeFormat"
                                  onChange={e => this.setState({origem: e.value})}
                                  id="contaOrigem"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="statusConta">Conta de Destino</label>
                        <Dropdown value={this.state.destino} 
                                  options={this.state.contasAtivas} 
                                  style={{width: '100%', height: '32px'}}
                                  optionLabel="nomeFormat" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nomeFormat"
                                  onChange={e => this.setState({destino: e.value})}
                                  id="contaDestino"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="saldo">Valor</label>
                        <InputNumber inputId="valorTrans" 
                                    value={this.state.valorTransferencia} 
                                    style={{width: '100%', height: '32px'}} 
                                    onChange={(e) => this.setState({valorTransferencia: e.value})} 
                                    mode="decimal" locale="de-BR" minFractionDigits={2}/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="saldo">Observação</label>
                        <InputTextarea id="obsTrans" 
                                       type="text" 
                                       style={{width: '100%'}} 
                                       value={this.state.observacaoTransferencia}
                                       onChange={e => this.setState({observacaoTransferencia: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"
                                       rows={4} cols={30}/>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="saldo">Anexar Arquivo</label>
                        <div className="container1">
                          
                          <Upload onUpload={this.handleUpload}/>
                          {!!upLoadFiles && (
                            <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                          )}
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{display: `${this.state.exibirArquivo}`}}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          &nbsp;
                          &nbsp;
                          <i className="pi pi-paperclip"></i>
                          &nbsp;
                          <strong>{this.state.fileName}</strong>
                          &nbsp;
                          &nbsp;
                          <a onClick={this.excluirArquivo} 
                             style={{cursor: 'pointer'}} title="Excluir Arquivo">
                            <i className="pi pi-times" style={{color: 'red', cursor: 'pointer'}}></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Consulta de Transferências */}
              <Dialog header="Consulta de Transfrências"
                      visible={this.state.modalConsultaTransferencias} 
                      
                      footer={
                        <div>
                            <Button label="Fechar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalConsultaTransferencias')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalConsultaTransferencias')}>
                  
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <Calendar id="transfDataInicial" 
                                  value={this.state.transfDataInicial} 
                                  onChange={(e) => this.setState({ transfDataInicial: e.value })} 
                                  locale="es"
                                  style={{height: '32px', width: '195px'}} 
                                  dateFormat="dd/mm/yy"
                                  placeholder="Data Inicial"
                                  mask="99/99/9999"/>
                        &nbsp;
                        <Calendar id="transfDataFinal" 
                                  value={this.state.transfDataFinal} 
                                  onChange={(e) => this.setState({ transfDataFinal: e.value })} 
                                  locale="es"
                                  style={{height: '32px', width: '195px'}} 
                                  dateFormat="dd/mm/yy"
                                  placeholder="Data Final"
                                  mask="99/99/9999"/>
                        &nbsp;
                        <Dropdown value={this.state.transfConta} 
                                  options={this.state.contas} 
                                  style={{width: '185px', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={(e) => this.setState({ transfConta: e.value })} 
                                  id="contaFiltro"
                                  placeholder="Conta Financeira"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                        &nbsp;
                        <Dropdown value={this.state.transfTipo} 
                                  options={this.tipos} 
                                  style={{width: '185px', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={(e) => this.setState({ transfTipo: e.value })} 
                                  id="tipoFiltro"
                                  placeholder="Tipo de Conta"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-md-12">
                      <Button label="Consultar" 
                              className="p-button-primary p-button-text"
                              onClick={this.consultarTransferencias}/> 
                      &nbsp;
                      <Button label="Nova Transferência" 
                            className="p-button-success p-button-text"
                            onClick={this.novaTransferencia}/>
                      &nbsp;
                      <Button label="Limpar" 
                              className="p-button-secondary p-button-text"
                              onClick={() => this.fecharModal('modalConsultaTransferencias')}/>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <DataTable value={this.state.transferencias}  responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks 
                              NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                              emptyMessage="Nenhuma transferência encontrada">
                            <Column field="origem.nome" header="Origem"></Column>
                            <Column field="destino.nome" header="Destino"></Column>
                            <Column field="valorFormat" header="Valor"></Column>
                            <Column field="dtRegistro" header="Data"></Column>
                            <Column field="observacao" header="Observacao"></Column>
                            <Column field="fileName" header="Anexo"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
              </Dialog>
          </section>
        </div>
      </>
    );
  }
}

ContaFinanceira.contextType = AuthContext;
export default withRouter (ContaFinanceira)